import { computed, makeAutoObservable } from 'mobx';
import { DateTime } from 'src_common/utils/time/time';
import { ConfigState } from 'src/AppState/ConfigState/ConfigState';
import { localStorageAnniversaryInfo } from './LocalStorageItems/localStorageAnniversaryInfo';
import { LocalStorageItemState } from './LocalStorageItemState';
import { localStorageRecentlyEvents } from 'src/AppState/LocalStorageState/LocalStorageItems/localStorageRecentlyEvents';
import { localStorageChatDrafts } from './LocalStorageItems/localStorageChatDrafts';

export class LocalStorageState {
    public readonly anniversaryInfo: LocalStorageItemState<boolean>;
    public readonly recentlyEvents: LocalStorageItemState<Array<number>>;
    public readonly chatDrafts: LocalStorageItemState<Record<string, string>>;
    public readonly configState: ConfigState;

    public constructor(configState: ConfigState) {
        this.anniversaryInfo = localStorageAnniversaryInfo(true, 'anniversary');
        this.recentlyEvents = localStorageRecentlyEvents(true, 'recentlyEvents');
        this.chatDrafts = localStorageChatDrafts(true, 'chatDrafts');
        this.configState = configState;
        makeAutoObservable(this);
    }

    @computed public get anniversaryInfoLocalStorage(): boolean {
        const anniversaryDate = DateTime.from('2022-02-28');
        const today = DateTime.from(Date.now());
        const isDateCorrect = anniversaryDate !== null && today !== null && anniversaryDate.isSameDay(today);
        const anniversaryUniverseFlag = this.configState.config.anniversaryInfoShow;
        return this.anniversaryInfo.getValue() === false && isDateCorrect && anniversaryUniverseFlag;
    }

    public setChatDraft(chatId: string, text: string): void {
        const drafts = { ...this.chatDrafts.getValue(), [chatId]: text };
        this.chatDrafts.setValue(drafts);
    }

    public getChatDraft(chatId: string): string {
        return this.chatDrafts.getValue()[chatId] ?? '';
    }

    public clearChatDraft(chatId: string): void {
        const drafts = this.chatDrafts.getValue();
        delete drafts[chatId];
        this.chatDrafts.setValue(drafts);
    }
}
